import { render } from "./SecretariatPage.vue?vue&type=template&id=00593cf0"
import script from "./SecretariatPage.vue?vue&type=script&lang=js"
export * from "./SecretariatPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__